/**
 * B2C Operations Module - Parent Component
 * Version: 1.2.0
 * Last Updated: 2025-12-17
 *
 * Description:
 *   Parent wrapper for B2C Operations sub-modules
 *   - Order Extractor
 *   - Label Generator
 *   - Price Monitor
 */

import { Routes, Route, Navigate } from 'react-router-dom';
import B2CManagementDashboard from './B2CManagementDashboard';
import OrderExtractor from './OrderExtractor';
import LabelGenerator from './LabelGenerator';
import LabelGeneratorV2 from './LabelGeneratorV2';
import MrpLabelGenerator from './MrpLabelGenerator';
import ThermalReceiptGenerator from './ThermalReceiptGenerator';
import WooToZohoExport from './WooToZohoExport';
import StockPriceUpdater from './StockPriceUpdater';
import PriceMonitor from './PriceMonitor';
import OrderPlaceTest from './OrderPlaceTest';
import SubscriptionManagement from './SubscriptionManagement';
import B2COrderList from './B2COrderList';
import OrderExtractorV2 from './OrderExtractorV2';
import DeliverySplitGenerator from './DeliverySplitGenerator';
import CleanUpUsers from './CleanUpUsers';
import PaymentLinkGenerator from './PaymentLinkGenerator';

export default function B2COpsModule() {
    return (
        <Routes>
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<B2CManagementDashboard />} />
            <Route path="order-extractor" element={<OrderExtractor />} />
            <Route path="order_extractor_v2" element={<OrderExtractorV2 />} />
            <Route path="b2c-order-list" element={<B2COrderList />} />
            <Route path="label-generator" element={<LabelGenerator />} />
            <Route path="label-generator-v2" element={<LabelGeneratorV2 />} />
            <Route path="payment-link-generator" element={<PaymentLinkGenerator />} />
            <Route path="delivery-split-generator" element={<DeliverySplitGenerator />} />
            <Route path="mrp-label-generator" element={<MrpLabelGenerator />} />
            <Route path="thermal-receipt" element={<ThermalReceiptGenerator />} />
            <Route path="woo-to-zoho-export" element={<WooToZohoExport />} />
            <Route path="stock-price-updater" element={<StockPriceUpdater />} />
            <Route path="price-monitor" element={<PriceMonitor />} />
            <Route path="order-place-test" element={<OrderPlaceTest />} />
            <Route path="subscriptions" element={<SubscriptionManagement />} />
            <Route path="clean-up-users" element={<CleanUpUsers />} />
        </Routes>
    );
}
